import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

const data = [
    {route: 'applicant', value: 'item1', text: 'مدیریت متقاضیان', icon: 'fa-solid fa-address-book' },
    {route: 'driver', value: 'item2', text: 'مدیریت رانندگان', icon: 'fa-solid fa-truck' },
    {route: 'request', value: 'item3', text: 'مدیریت درخواست ها', icon: 'fa-envelope' },
    {route: 'report', value: 'item4', text: 'گزارش گیری', icon: 'fa-book' },
    {route: 'users', value: 'item5', text: 'مدیریت کاربران', icon: 'fa-users' },
]

const RightMenu = () => {
    const [hideMenu, setHideMenu] = useState(false)
    const [selectedItem, setSelectedItem] = useState('item1')
    const navigate = useNavigate();
    const handleShowAndHide = () => {
        setHideMenu(!hideMenu)
    }

    useEffect(() => {
        function handleResize(){
            if(window.innerWidth < 992){
                setHideMenu(true)
            }
            else {
                setHideMenu(false)
            }
        }
        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const handleClick = (e, item) => {
        setSelectedItem(item)
        if(window.innerWidth < 992){
            setHideMenu(true)
        }
    }

    return(
        <div className={`${hideMenu && 'hideRightMenu'} right-menu`}>
            <div><i className="fa fa-bars bar-icon" onClick={handleShowAndHide}></i></div>
            <div className='tabs-box'>
                {data.map((item, index) => {
                    return(
                        <div key={index} className={`item ${selectedItem === item.value && 'selected-item'}`}
                             onClick={(e) => {navigate(item.route);handleClick(e, item.value)}}>
                            <div className='text'>{item.text}</div>
                            <i className={`fa ${item.icon}`}></i>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default RightMenu